import book01 from './../img/book/Book-01.jpg';
import book02 from './../img/book/Book-02.jpg';
import book03 from './../img/book/Book-03.jpg';
import book04 from './../img/book/Book-04.jpg';
import book05 from './../img/book/Book-05.jpg';
import book06 from './../img/book/Book-06.jpg';
import book07 from './../img/book/Book-07.jpg';
import book08 from './../img/book/Book-08.jpg';
import book09 from './../img/book/Book-09.jpg';
import book10 from './../img/book/Book-10.jpg';
import book11 from './../img/book/Book-11.jpg';
import book12 from './../img/book/Book-12.jpg';
import book13 from './../img/book/Book-13.jpg';
import book14 from './../img/book/Book-14.jpg';
import book15 from './../img/book/Book-15.jpg';
import book16 from './../img/book/Book-16.jpg';
import book17 from './../img/book/Book-17.jpg';
import book18 from './../img/book/Book-18.jpg';
import book19 from './../img/book/Book-19.jpg';
import book20 from './../img/book/Book-20.jpg';
import book21 from './../img/book/Book-21.jpg';
import book22 from './../img/book/Book-22.jpg';
import book23 from './../img/book/Book-23.jpg';
import book24 from './../img/book/Book-24.jpg';
import book25 from './../img/book/Book-25.jpg';
import book26 from './../img/book/Book-26.jpg';
import book27 from './../img/book/Book-27.jpg';
import book28 from './../img/book/Book-28.jpg';
import book29 from './../img/book/Book-29.jpg';
import book30 from './../img/book/Book-30.jpg';
import book31 from './../img/book/Book-31.jpg';
import book32 from './../img/book/Book-32.jpg';
import book33 from './../img/book/Book-33.jpg';
import book34 from './../img/book/Book-34.jpg';
import book35 from './../img/book/Book-35.jpg';
import book36 from './../img/book/Book-36.jpg';
import book37 from './../img/book/Book-37.jpg';
import book38 from './../img/book/Book-38.jpg';
import book39 from './../img/book/Book-39.jpg';
import book40 from './../img/book/Book-40.jpg';
import book41 from './../img/book/Book-41.jpg';
import book42 from './../img/book/Book-42.jpg';
import book43 from './../img/book/Book-43.jpg';
import book44 from './../img/book/Book-44.jpg';

const books = [
  {
    id: 1,
    image: book01,
    title: 'Page 1 Title',
    content: 'This is the content for page 1.',
  },
  {
    id: 2,
    image: book02,
    title: 'Page 2 Title',
    content: 'This is the content for page 2.',
  },
  {
    id: 3,
    image: book03,
    title: 'Page 3 Title',
    content: 'This is the content for page 3.',
  },
  {
    id: 4,
    image: book04,
    title: 'Page 4 Title',
    content: 'This is the content for page 4.',
  },
  {
    id: 5,
    image: book05,
    title: 'Page 5 Title',
    content: 'This is the content for page 5.',
  },
  {
    id: 6,
    image: book06,
    title: 'Page 6 Title',
    content: 'This is the content for page 6.',
  },
  {
    id: 7,
    image: book07,
    title: 'Page 7 Title',
    content: 'This is the content for page 7.',
  },
  {
    id: 8,
    image: book08,
    title: 'Page 8 Title',
    content: 'This is the content for page 8.',
  },
  {
    id: 9,
    image: book09,
    title: 'Page 9 Title',
    content: 'This is the content for page 9.',
  },
  {
    id: 10,
    image: book10,
    title: 'Page 10 Title',
    content: 'This is the content for page 10.',
  },
  {
    id: 11,
    image: book11,
    title: 'Page 11 Title',
    content: 'This is the content for page 11.',
  },
  {
    id: 12,
    image: book12,
    title: 'Page 12 Title',
    content: 'This is the content for page 12.',
  },
  {
    id: 13,
    image: book13,
    title: 'Page 13 Title',
    content: 'This is the content for page 13.',
  },
  {
    id: 14,
    image: book14,
    title: 'Page 14 Title',
    content: 'This is the content for page 14.',
  },
  {
    id: 15,
    image: book15,
    title: 'Page 15 Title',
    content: 'This is the content for page 15.',
  },
  {
    id: 16,
    image: book16,
    title: 'Page 16 Title',
    content: 'This is the content for page 16.',
  },
  {
    id: 17,
    image: book17,
    title: 'Page 17 Title',
    content: 'This is the content for page 17.',
  },
  {
    id: 18,
    image: book18,
    title: 'Page 18 Title',
    content: 'This is the content for page 18.',
  },
  {
    id: 19,
    image: book19,
    title: 'Page 19 Title',
    content: 'This is the content for page 19.',
  },
  {
    id: 20,
    image: book20,
    title: 'Page 20 Title',
    content: 'This is the content for page 20.',
  },
  {
    id: 21,
    image: book21,
    title: 'Page 21 Title',
    content: 'This is the content for page 21.',
  },
  {
    id: 22,
    image: book22,
    title: 'Page 22 Title',
    content: 'This is the content for page 22.',
  },
  {
    id: 23,
    image: book23,
    title: 'Page 23 Title',
    content: 'This is the content for page 23.',
  },
  {
    id: 24,
    image: book24,
    title: 'Page 24 Title',
    content: 'This is the content for page 24.',
  },
  {
    id: 25,
    image: book25,
    title: 'Page 25 Title',
    content: 'This is the content for page 25.',
  },
  {
    id: 26,
    image: book26,
    title: 'Page 26 Title',
    content: 'This is the content for page 26.',
  },
  {
    id: 27,
    image: book27,
    title: 'Page 27 Title',
    content: 'This is the content for page 27.',
  },
  {
    id: 28,
    image: book28,
    title: 'Page 28 Title',
    content: 'This is the content for page 28.',
  },
  {
    id: 29,
    image: book29,
    title: 'Page 29 Title',
    content: 'This is the content for page 29.',
  },
  {
    id: 30,
    image: book30,
    title: 'Page 30 Title',
    content: 'This is the content for page 30.',
  },
  {
    id: 31,
    image: book31,
    title: 'Page 31 Title',
    content: 'This is the content for page 31.',
  },
  {
    id: 32,
    image: book32,
    title: 'Page 32 Title',
    content: 'This is the content for page 32.',
  },
  {
    id: 33,
    image: book33,
    title: 'Page 33 Title',
    content: 'This is the content for page 33.',
  },
  {
    id: 34,
    image: book34,
    title: 'Page 34 Title',
    content: 'This is the content for page 34.',
  },
  {
    id: 35,
    image: book35,
    title: 'Page 35 Title',
    content: 'This is the content for page 35.',
  },
  {
    id: 36,
    image: book36,
    title: 'Page 36 Title',
    content: 'This is the content for page 36.',
  },
  {
    id: 37,
    image: book37,
    title: 'Page 37 Title',
    content: 'This is the content for page 37.',
  },
  {
    id: 38,
    image: book38,
    title: 'Page 38 Title',
    content: 'This is the content for page 38.',
  },
  {
    id: 39,
    image: book39,
    title: 'Page 39 Title',
    content: 'This is the content for page 39.',
  },
  {
    id: 40,
    image: book40,
    title: 'Page 40 Title',
    content: 'This is the content for page 40.',
  },
  {
    id: 41,
    image: book41,
    title: 'Page 41 Title',
    content: 'This is the content for page 41.',
  },
  {
    id: 42,
    image: book42,
    title: 'Page 42 Title',
    content: 'This is the content for page 42.',
  },
  {
    id: 43,
    image: book43,
    title: 'Page 43 Title',
    content: 'This is the content for page 43.',
  },
  {
    id: 44,
    image: book44,
    title: 'Page 44 Title',
    content: 'This is the content for page 44.',
  },

];

export default books;